import { defineMessage } from 'react-intl'

const POSITION_OPTIONS = [
    {
        label: defineMessage({ defaultMessage: "Oben, linksbündig" }),
        value: "top-left"
    }, {
        label: defineMessage({ defaultMessage: "Oben, zentriert" }),
        value: "top-center"
    }, {
        label: defineMessage({ defaultMessage: "Oben, rechtsbündig" }),
        value: "top-right"
    }, {
        label: defineMessage({ defaultMessage: "Mitte, linksbündig" }),
        value: "center-left"
    }, {
        label: defineMessage({ defaultMessage: "Mitte, zentriert" }),
        value: "center-center",
        default: true
    }, {
        label: defineMessage({ defaultMessage: "Mitte, rechtsbündig" }),
        value: "center-right"
    }, {
        label: defineMessage({ defaultMessage: "Unten, linksbündig" }),
        value: "bottom-left"
    }, {
        label: defineMessage({ defaultMessage: "Unten, zentriert" }),
        value: "bottom-center"
    }, {
        label: defineMessage({ defaultMessage: "Unten, rechtsbündig" }),
        value: "bottom-right"
    }
]

export default POSITION_OPTIONS